import { Chip, Colors, Text } from 'library';
import React from 'react';

export default function PaymentChoices({
    icon,
    title,
    subtitle,
    highlight,
    listItems,
    cardItems,
    id,
}: {
    title: string;
    highlight?: string;
    subtitle?: string;
    icon?: React.ReactNode;
    listItems?: string[];
    cardItems?: { backgroundColor: string; text: string }[];
    id?: string;
}) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                height: '100%',
            }}
            id={id}
        >
            <div style={{ marginLeft: 10, textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: 20 }}>{icon}</div>
                <div style={{ marginBottom: 20, minHeight: 80 }}>
                    <Text variant="h1" bold textStyle={{ color: Colors.turquoise, textAlign: 'center' }}>
                        {title}
                    </Text>
                    <Text variant="body2" textStyle={{ textAlign: 'center' }}>
                        {subtitle}
                    </Text>
                </div>
                {highlight ? (
                    <div style={{ minHeight: 80 }}>
                        <Text
                            variant="body2"
                            inline
                            bold
                            color={Colors.turquoise}
                            textStyle={{ marginBottom: 20, textAlign: 'center' }}
                        >
                            {highlight}
                        </Text>
                    </div>
                ) : null}
                {listItems ? (
                    <ul style={{ paddingInlineStart: 0 }}>
                        {listItems.map((l: string) => (
                            <li>
                                <Text variant="caption">{l}</Text>
                            </li>
                        ))}
                    </ul>
                ) : null}

                {cardItems
                    ? cardItems.map((c) => (
                          <Chip
                              key={c.text + title}
                              label={c.text}
                              backgroundColor={c.backgroundColor}
                              style={{ margin: 5 }}
                          />
                      ))
                    : null}
            </div>
        </div>
    );
}
